import React, { useMemo, useState } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { TextArea } from '@progress/kendo-react-inputs';
import { fetchApi } from '../../../services/api';
import { JsonResponse } from 'TypeGen/json-response';

type Props = {
  workOrderId: number;
  onClose: () => void;
  onNoteCreated: () => void;
};

const AddWorkOrderNoteDialog: React.FC<Props> = ({ workOrderId, onClose, onNoteCreated }) => {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);

  const canSave = useMemo(() => {
    const trimmed = note.trim();
    return trimmed.length > 0 && !saving;
  }, [note, saving]);

  const handleClose = () => {
    if (saving) {
      return;
    }

    setNote('');
    onClose();
  };

  const handleSave = () => {

    if (!canSave) {
      return;
    }

    setSaving(true);

    const payload = {
      WorkOrderID: workOrderId,
      Note: note.trim()
    };

    fetchApi('/api/ShopWorkOrder/AddWorkOrderNote', payload, 'POST')
      .then((response: JsonResponse) => {
        if (response.Success) {
          onNoteCreated();
        } else {
          alert(response.ErrorMessage);
        }
      })
      .catch((e) => {
        // If not problem details
        if (!e?.status) alert('Unable to add note.');
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <Dialog title="Add Work Order Note" className="dialog-w525" onClose={handleClose}>
      <div className="k-form k-form-md p-0">
        <TextArea autoFocus disabled={saving} rows={8} placeholder="Note..." value={note} onChange={e => setNote(e.value)} />
      </div>
      <DialogActionsBar>
        <Button type="button" onClick={handleClose} disabled={saving}>
          Cancel
        </Button>
        <Button type="button" onClick={handleSave} themeColor="primary" disabled={!canSave}>
          Add Note
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default AddWorkOrderNoteDialog;
